<template>
  <div class="meals-table mt-4">
    <app-table
      :loading="loading"
      :data="data ? data : []"
      :fields="fields"
      :rules="tableRules"
      @reload="reloadData"
      @edit="handleEdit"
      @delete="handleDelete"
    />
    <category-ing-modal :show.sync="modal.show" :title="modal.title" action="edit" />
  </div>
</template>

<script>
import { AppTable } from '@/app/shared/components';
import { mapActions, mapGetters } from 'vuex';
import { LOADING, DATA, ERROR } from '../shared/state/types/getter_types';
import CategoryIngModal from '../categoryIng-modal/categoryIng-modal.vue';
import { SELECT_CAT_ING, DELETE_CAT_ING, FETCH_CAT_ING } from '../shared/state/types/action_types';
import { notifyMixin } from '../shared/mixins/notify-mixin';

export default {
  name: 'CategoryIngTable',
  components: { AppTable, CategoryIngModal },
  mixins: [notifyMixin],
  data() {
    return {
      fields: [
        { label: '#', value: 'id', width: 100 },
        { label: 'Название', value: 'title' },
      ],
      tableRules: [
        {
          value: 'edit',
          type: 'primary',
          icon: 'el-icon-edit',
        },
        {
          value: 'delete',
          type: 'danger',
          icon: 'el-icon-delete',
        },
      ],
      modal: {
        show: false,
        title: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      loading: LOADING,
      data: DATA,
      error: ERROR,
    }),
  },
  methods: {
    ...mapActions({ select: SELECT_CAT_ING, delete: DELETE_CAT_ING, fetch: FETCH_CAT_ING }),
    async reloadData(page) {
      await this.fetch({ page });
    },
    async handleEdit(branch) {
      this.select(branch);
      this.modal.show = true;
      this.modal.title = 'Редактирование категории приема пищи';
    },
    handleDelete(meal) {
      this.$confirm('Вы точно хотите удалить?', 'Предупреждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Закрыть',
        type: 'warning',
      })
        .then(async () => {
          await this.delete(meal.id);
          if (this.error) {
            this.showErrorMessage('Ошибка удаления');
          }
          this.showSuccessMessage('Успешно удален');
        })
        .catch(() => {});
    },
  },
};
</script>
